import Vue from 'vue'
import config from '@/config'
import store from '@/store'
import lib from '@/library'
import priceFormat from '@/library/priceFormat'
import interRelatedService from '@/library/interRelated'
import teaserPriceType from '@/library/teaserPriceType'

let clone = function (obj) {
  return JSON.parse(JSON.stringify(obj))
}

const actions = {
  /**
   * Toggle (add/remove) selection to betslip
   * @param {any} context
   * @param {{'selection':{Object}, 'market':{Object}, 'event':{Object}, 'sendgtmevent':{Boolean}, origin:{String}}} selectionData only selection is mandatory, the rest are optional
   */
  toggleBetslipSelection (context, selectionData) {
    // !!! USED BY EXTERNAL COMPONENT !!!
    // console.log('toggleBetslipSelection action:', selectionData)
    var t = new Date().getTime()
    //
    if (context.state.currentBetSlipState >= 1) {
      var autoDismissInCase = {
        0: false,
        1: false,
        2: true,
        3: false,
        4: false
      }
      if (context.state.currentBetSlipState === 5 && autoDismissInCase[context.state.attemptedBetSlip.betSlipStatus.State]) {
        // context.commit('setActiveBetSlipHistoryTab', '')
        context.dispatch('dismissBetSlip', {keep: true}).then(function () {
          context.dispatch('toggleBetslipSelection', selectionData)
        })
      } else {
        store.dispatch('overlayState/activateBetslipMsg', ['NOT_IDLE'])
      }
      return
    }
    //
    var selection = selectionData['selection']
    const id = parseFloat(selection.idfoselection)
    var isInBetSlip = !!context.state.betslipSelectionsIds[id]
    //
    context.commit('dismissErrorFromSelection')
    //
    setTimeout(() => {
      context.dispatch('saveToStorage')
    }, 1)
    //
    if (isInBetSlip) {
      var tt = context.state.toggleTime[id] || 0
      var dt = t - tt
      // console.log('Toggle time delta: ' + dt)
      if (dt > 1000) {
        context.dispatch('removeSelection', selectionData)
      }
    } else {
      Vue.set(context.state.toggleTime, id, t)
      return context.dispatch('addSelection', selectionData)
    }
    //
    // context.dispatch('saveToStorage')
  },
  addSelection (context, selectionData) {
    // console.log('addSelection', selectionData)
    //
    var state = context.state
    var preventAdding = false
    if (state.betslipSelections.length >= context.getters.maxSno) {
      preventAdding = ['MAX_NO', context.getters.maxSno]
    }
    var event = selectionData['event'] || {}
    var market = clone(selectionData['market'] || {})
    market.awaypitchername = market.awaypitchername || event.awaypitchername
    market.homepitchername = market.homepitchername || event.homepitchername
    if (market && !market.idfosport && event && event.idfosport) {
      market.idfosport = event.idfosport
    }

    if (market.V) {
      lib.WebSocketLiveService.subscribeToMarketsByIDFOMarkets([market])
    }
    //
    var istradable = market && market.istradable && JSON.parse(market.istradable)
    if (!istradable) {
      if (!(state.addingMiltipleSelections.allowSuspended && state.addingMiltipleSelections.inProgress)) {
        // console.log('Selection is Suspended!')
        preventAdding = ['SUSPENDED']
        return
      }
    }
    //
    var selection = clone(selectionData['selection'])
    //
    if ((selection.idfobolifestate && selection.idfobolifestate === 'NR') || (selection.idfoselectionsuspensiontype && selection.idfoselectionsuspensiontype === 'N/O')) {
      // console.log('Selection suspended by idfobolifestate:', selection.idfobolifestate)
      // console.log('Selection idfoselectionsuspensiontype is ' + selection.idfoselectionsuspensiontype + '!')
      preventAdding = ['NR']
      return
    }
    if (config && config.app && config.app.businessChannel &&
      ((selection.idfoselectionsuspensiontype && (selection.idfoselectionsuspensiontype.split(',').includes(config.app.businessChannel) || selection.idfoselectionsuspensiontype.split(',').includes('N/O'))) ||
        (selection.nontradableon && (selection.nontradableon.split(',').includes(config.app.businessChannel) || selection.nontradableon.split(',').includes('N/O'))) ||
        (selection.hiddenfrom && (selection.hiddenfrom.split(',').includes(config.app.businessChannel) || selection.hiddenfrom.split(',').includes('N/O')))
      )) {
      // console.log('Selection suspended due idfoselectionsuspensiontype:', selection.idfoselectionsuspensiontype, 'contains:', config.app.businessChannel)
      // console.log('Selection is Suspended per BusinessChannel!')
      preventAdding = ['SUSPENDED']
      return
    }
    if ((!selection.currentpricedown || !selection.currentpriceup) && !state.addingMiltipleSelections.inProgress) {
      // console.log('Selection has no price!')
      preventAdding = ['NO_PRICE']
      return
    }
    //
    if (preventAdding) {
      store.dispatch('overlayState/activateBetslipMsg', preventAdding)
      return
    }
    //
    const id = parseFloat(selection.idfoselection)
    market.csvpricetypes = market.csvpricetypes || // default case
      (market.pricetypes && market.pricetypes[0] && market.pricetypes.map(p => p.idfopricetype).join(',')) || // inject selections
      (market.pricetypes && market.pricetypes.pricetype && market.pricetypes.pricetype['#text']) ||
      market.activepricetypes // LiveWire
    market.csvpricetypes = market.csvpricetypes && market.csvpricetypes.split(',')
    selection.csvpricetypes = market.csvpricetypes || ''
    context.commit('setPriceType', selection)
    market.selections = []

    Vue.set(state.markets, id, market)
    Vue.set(state.idfomarkets, id, market.idfomarket)
    Vue.set(state.idfoevents, id, market.idfoevent)
    Vue.set(selection, 'selectionhashcode', null)
    Vue.set(selection, 'selectionHasSuspensionPerBusinessChannel', false)
    Vue.set(selection, 'marketname', market.name)
    Vue.set(selection, 'idfomarket', selection.idfomarket || market.idfomarket)
    Vue.set(selection, 'eventname', market.eventname)
    Vue.set(selection, 'idfoevent', market.idfoevent)
    Vue.set(selection, 'csvavailablebettypes', market.csvavailablebettypes ? market.csvavailablebettypes.split(',') : [])
    Vue.set(selection, 'istradable', istradable)
    Vue.set(selection, 'isclosed', false)
    Vue.set(selection, 'tsstart', market.tsstart)
    Vue.set(selection, 'awaypitchername', market.awaypitchername)
    Vue.set(selection, 'homepitchername', market.homepitchername)
    Vue.set(selection, 'idfosport', market.idfosport)
    // Vue.set(selection, 'hasDerivative', false)
    if (!selection.idfosporttype) {
      Vue.set(selection, 'idfosporttype', market.idfosporttype)
    }
    if (event && event.fosporttypename) {
      Vue.set(selection, 'fosporttypename', event.fosporttypename.toUpperCase() || null)
    }
    if (!selection.sportname && event) {
      Vue.set(selection, 'sportname', event.fosportname || event.sportname || event.idfosport || (market && market.idfosport) || null)
    }
    Vue.set(selection, 'price', priceFormat.reCalculatePrice(selection))
    //
    let isForBB = context.getters.isBBenabled && (market.BB || (market.buybackmargin && (!market.buybackavonchannel || market.buybackavonchannel.split(',').indexOf('W3') > -1)))
    Vue.set(selection, 'isForBB', !!isForBB)
    //
    // console.log('selection.origin:', selection.origin, '; origin:', (selectionData['origin'] || null))
    let sendOrigin = context.getters.sendOrigin
    if (sendOrigin) {
      let origin = selectionData['origin'] || null
      let sendMMorigin = context.getters.sendMMorigin
      if (!sendMMorigin && context.getters.isMMorigin(origin)) {
        let sendMMoriginForPopularParlays = context.getters.sendMMoriginForPopularParlays
        if (!(sendMMoriginForPopularParlays && selection.originPopularParlay)) {
          origin = null
        }
      }
      Vue.set(selection, 'origin', selection.origin || origin)
    }
    //
    context.commit('addTeaserSelectionsData', selection)
    //
    Vue.set(state.optedIn.REGULAR, id, true)
    Vue.set(state.optedIn.RR, id, true)
    // if (selection.csvavailablebettypes && selection.csvavailablebettypes.length > 1) {Vue.set(state.optedIn.RR, id, true)}
    //
    var derivativetypes = market.derivativetypes
    if (derivativetypes) {
      Vue.set(selection, 'derivativetypes', derivativetypes.split(','))
    }
    //
    state.betslipSelections.push(clone(selection))
    state.betslipSelectionIds.push(id)
    Vue.set(state.betslipSelectionsIds, id, true)
    //
    state.interRelated = interRelatedService.checkInterRelated(state.betslipSelections, state.markets)
    //
    var abtnr = {
      'PotentialReturn': selection.price,
      'TotalStake': 1,
      'UnitCount': 1
    }
    Vue.set(context.state.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerSelection, selection.idfoselection, abtnr)
    //
    if (context.getters.multiSinglesStake) {
      Vue.set(context.state.betTypeStakes.REGULAR.PerSelection, selection.idfoselection, context.getters.multiSinglesStake)
    }
    //
    context.dispatch('checkDerivatives', [state.betslipSelections[state.betslipSelections.length - 1], market])
    //
    var activateSingleBetslip = context.getters.isFastBetEnabled
    //
    if (state.betslipSelections.length === 1) {
      activateSingleBetslip = activateSingleBetslip && store.getters['screenState/getMobileBigAndBelow']
      if (activateSingleBetslip && !market.silent) {
        if (context.getters.rememberSingleBetSlipStake) {
          var sstake = context.getters.singleBetSlipStake
          if (sstake) {
            Vue.set(state.betTypeStakes.REGULAR.PerSelection, selection.idfoselection, sstake)
          }
        }
        store.dispatch('overlayState/activateSingleBetslip').then(function (r) {
          // console.log('resolve SingleBetslip: ' + r)
          document.activeElement.blur()

          if (r) {
            /*
            if (r === 'hide') {
            } else {
              context.dispatch('clearFastBetSlip', selection)
            }
            */
          } else {
            context.dispatch('clearFastBetSlip', selection)
          }
          store.dispatch('overlayState/deactivateSingleBetslip').then(function () {
            store.commit('sbBetslipState/setActiveBetSlip', false)
          })
        })
      }
    }

    if (activateSingleBetslip && state.betslipSelections.length > 1) {
      // console.log('hide FastBet on add selection')
      var dialogSingleBetslip = store.getters['overlayState/getSingleBetslipState']
      // console.log('get dialogSingleBetslip')
      if (dialogSingleBetslip && dialogSingleBetslip.active) {
        dialogSingleBetslip.resolve(false)
      }
    }
    //
    return selection
  },

  removeSelection (context, selectionData) {
    var selection = selectionData['selection']
    var sendgtmevent = selectionData['sendgtmevent']
    if (sendgtmevent) {
      context.dispatch('dispatchGTM', {method: 'sendGTMRemoveSelectionFromBetslip', data: [selection]})
    }
    // console.log('removeSelection')
    // console.log('typeof selection: ' + typeof selection)
    context.dispatch('unsubscribeFromMarket', selection)
    //
    var state = context.state
    const id = typeof selection === 'object' ? parseFloat(selection.idfoselection) : selection

    if (state.betslipSelectionIds.length === 1 && state.betslipSelectionIds[0] === id) {
      context.commit('clearBetSlip')
      context.dispatch('clearApplicableVouchersData')
    } else {
      var index = state.betslipSelectionIds.indexOf(id)
      if (index > -1) {
        if (typeof selection === 'object') {
          selection.isSelected = false
        }
        state.betslipSelections.splice(index, 1)
        state.betslipSelectionIds.splice(index, 1)
      }
      //
      Vue.delete(state.betslipSelectionsIds, id)
      Vue.delete(state.markets, id)
      Vue.delete(state.idfomarkets, id)
      Vue.delete(state.idfoevents, id)
      Vue.delete(state.betTypeStakes.REGULAR.PerSelection, id)
      Vue.delete(state.returns.REGULAR.PerSelection, id)
      Vue.delete(state.optedIn.REGULAR, id)
      Vue.delete(state.optedIn.RR, id)
      Vue.delete(state.optedIn.TEASER, id)
      for (let tpt in state.derivatives.teasers.T) {
        Vue.delete(state.derivatives.teasers.T[tpt], id)
      }
      Vue.delete(state.toggleTime, id)
      //
      if (state.config.derivatives.teasers.enabled && !context.getters.useSelectionTeaserInfos) {
        for (var g = 0; g < state.derivatives.teasers.teaserGroups.length; g++) {
          let group = state.derivatives.teasers.teaserGroups[g]
          for (var s = 0; s < group.Selections.length; s++) {
            if (group.Selections[s].IDFOSelection === id) {
              Vue.delete(group.Selections, s)
              context.dispatch('scheduleGetTeaserGroups')
              break
            }
          }
        }
        //
        context.commit('resetActiveTeaser')
      }
      //
      if (state.config.derivatives.pitchers.enabled && state.derivatives.pitchers && state.derivatives.pitchers.derived && state.derivatives.pitchers.derived[id] && state.derivatives.pitchers.derived[id].length) {
        state.derivatives.pitchers.derived[id].forEach(function (p) {
          Vue.delete(state.derivatives.pitchers.sourceMap, p.idfoselection)
        })
        Vue.delete(state.derivatives.pitchers.derived, id)
      }
      //
      if (state.config.derivatives.buyPoints.enabled && state.derivatives.buyPoints && state.derivatives.buyPoints.derived && state.derivatives.buyPoints.derived[id] && state.derivatives.buyPoints.derived[id].length) {
        state.derivatives.buyPoints.derived[id].forEach(function (p) {
          Vue.delete(state.derivatives.buyPoints.sourceMap, p.idfoselection)
        })
        Vue.delete(state.derivatives.buyPoints.derived, id)
      }
      //
    }
    state.interRelated = interRelatedService.checkInterRelated(state.betslipSelections, state.markets)
    //
    store.dispatch('overlayState/deactivateSingleBetslip')
  },

  activateBetslipMsg (context, reasonsArr) {
    store.dispatch('overlayState/activateBetslipMsg', reasonsArr)
  },

  unsubscribeFromMarket (context, selection) {
    if (selection['@type']) {
      let liveEvents = store.getters['livebettingState/liveEvents']
      let matketToUnsubscribe

      for (let i = 0; i < liveEvents.length; i++) {
        matketToUnsubscribe = liveEvents[i].markets && liveEvents[i].markets.find(mk => mk.idfomarket === selection.idfomarket)
        if (matketToUnsubscribe) {
          break
        }
      }

      if (matketToUnsubscribe && matketToUnsubscribe.V) {
        lib.WebSocketLiveService.unsubscribeFromMarkets([matketToUnsubscribe])
      }
    }
  },

  unsubscribeFromAllMarkets (context) {
    var marketsToUnsubscribe = []
    let liveEvents = store.getters['livebettingState/liveEvents']

    if (context.state.betslipSelections && context.state.betslipSelections.length > 0) {
      context.state.betslipSelections.forEach(betslipSelections => {
        liveEvents.forEach(ev => {
          let market = ev.markets && ev.markets.find(mk => mk.idfomarket === betslipSelections.idfomarket)
          if (market) {
            marketsToUnsubscribe.push(market)
          }
        })
      })

      if (marketsToUnsubscribe.length > 0) {
        lib.WebSocketLiveService.unsubscribeFromMarkets(marketsToUnsubscribe)
      }
    }
  },

  clearBetSlip (context, data) {
    // console.log('clearBetSlip')
    data = data || {}
    var clearData = function () {
      context.dispatch('unsubscribeFromAllMarkets')
      context.commit('clearBetSlip')
      context.dispatch('clearAttemptedBetSlip')
      context.dispatch('clearApplicableVouchersData')
      context.commit('resetABTnRrequestData')

      store.dispatch('overlayState/deactivateSingleBetslip')
    }
    if (data.onButtonClick) {
      context.dispatch('dispatchGTM', {method: 'sendGTMRemoveAllSelectionsFromBetslip'}).finally(function () {
        clearData()
      })
    } else {
      clearData()
    }
    if (!data.keepMobileBetSlipActive) {
      store.dispatch('overlayState/deactivateBetslip')
    }
    //
    context.dispatch('clearStoredBetSlip')
  },

  clearFastBetSlip (context, selection) {
    let preserveFastBetStakeForMain = context.getters.preserveFastBetStakeForMain
    if (!preserveFastBetStakeForMain) {
      Vue.delete(context.state.betTypeStakes.REGULAR.PerSelection, selection.idfoselection)
      Vue.delete(context.state.returns.REGULAR.PerSelection, selection.idfoselection)
    }
  },

  async injectXSelections (context, {selections, origin, popularParlaysIDFWMarketGroup}) {
    if (selections && selections.length) {
      selections.forEach(item => {
        let selection = item.selections[0]
        let market = item.market
        if (!market.derivativetypes && market.csvderivativetype) {
          market.derivativetypes = market.csvderivativetype
        }
        selection.idfosport = selection.idfosport || market.idfosport
        selection.idfosporttype = selection.idfosporttype || market.idfosporttype
        selection.idfoselectionsource = selection.idfoselectionsource || selection.IdFOSelectionSource
        selection.idfomarketsource = selection.idfomarketsource || selection.IdFOMarketSource
        if (popularParlaysIDFWMarketGroup) {
          selection.originPopularParlay = popularParlaysIDFWMarketGroup
          selection.popularParlay = {iDFWMarketGroup: popularParlaysIDFWMarketGroup}
        }
        if (selection.origin && context.getters.isMMorigin(selection.origin) && origin) {
          selection.origin += '|' + origin
        }
      })
    }
    // console.log('injectXSelections:', new Date().getTime(), selections)
    let ts = new Date().getTime()
    //
    const sleep = (ms) => {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
    //
    context.dispatch('clearBetSlip')
    context.dispatch('resetBetSlipChanges')
    context.commit('setAddingMiltipleSelections', true)
    //
    let priceTypes = selections.map(s => s.market.csvpricetypes.split(','))
    priceTypes = Vue._.flatten(priceTypes)
    priceTypes = Vue._.uniq(priceTypes)
    let pt = priceTypes && priceTypes.length === 1 && priceTypes[0]
    let isTeaser = !!pt && teaserPriceType.isTeaserPriceType(pt) && pt
    // console.log('priceTypes:', priceTypes, 'pt:', pt, 'isTeaser:', isTeaser)
    if (isTeaser) {
      let tId = null
      if (context.getters.useSelectionTeaserInfos) {
        let groupingParam = context.getters.teasersGrouping
        let idfosport = []
        let idfosporttype = []
        let teaserSelections = selections.map(s => s.selections[0])
        for (let s of teaserSelections) {
          tId = groupingParam === 'MIXED' ? groupingParam : s[groupingParam]
          if (!idfosport.includes(s.idfosport)) {
            idfosport.push(s.idfosport)
          }
          if (!idfosporttype.includes(s.idfosporttype)) {
            idfosporttype.push(s.idfosporttype)
          }
        }
        if (groupingParam === 'idfosport') {
          if (idfosport.length === 1 && idfosporttype.length === 1) {
            if (idfosport[0] !== idfosporttype[0]) {
              if (idfosporttype[0] === 'BASKETBALL') {
                tId = 'COLLBB'
              }
              if (idfosporttype[0] === 'NFL') {
                tId = 'COLLFB'
              }
            }
          } else {
            tId = null
          }
        }
      }
      if (tId) {
        Vue.set(context.state.derivatives.teasers.activeByGroup, tId, isTeaser)
      } else {
        for (let a in context.state.derivatives.teasers.activeByGroup) {
          Vue.set(context.state.derivatives.teasers.activeByGroup, a, isTeaser)
        }
      }
    }
    context.commit('setTab', isTeaser ? 'TEASER' : 'REGULAR')
    //
    const fetchSourceSelections = (selections) => {
      let idfoselections = selections.map(d => {
        return d.selections[0].idfoselectionsource !== d.selections[0].idfoselection && d.selections[0].idfoselectionsource
      }).filter(id => !!id)
      // console.log('idfoselections:', idfoselections)
      //
      return new Promise((resolve, reject) => {
        if (!idfoselections.length) {
          return resolve([])
        }
        idfoselections = idfoselections.join('-')
        return lib.kansas.marketsbyselections({
          idfoselections: idfoselections
        }).then(response => {
          // console.log('fetchSelections:', response.data)
          if (response && response.data && response.data.market) {
            return resolve(response.data.market)
          }
          return resolve([])
        }).catch((error) => {
          console.log('Error fetching marketsbyselections:', error)
          return resolve([])
        })
      })
    }
    //
    return new Promise((resolve, reject) => {
      let n = 0
      fetchSourceSelections(selections).then(sourceSelections => {
        // let src = sourceSelections && sourceSelections.length ? sourceSelections : selections
        let src = selections.map(item => {
          let selection = item.selections[0]
          let market = item.market
          if (!market.derivativetypes && market.csvderivativetype) {
            market.derivativetypes = market.csvderivativetype
          }
          let sourceSelection = sourceSelections.find(s => {
            let b = s.selections[0].idfoselection === selection.idfoselectionsource
            if (b) {
              s.selections[0].origin = selection.origin
              s.selections[0].activeDerivative = selection.idfoselection
              s.selections[0].isTeaserSource = isTeaser
              if (market.derivativetype === 'PP') {
                s.selections[0].isPitcherSource = 'PP'
              }
              if (market.derivativetype === 'HP') {
                s.selections[0].isBuyPointsSource = 'HP'
              }
              if (selection.originPopularParlay) {
                s.selections[0].originPopularParlay = selection.originPopularParlay
              }
            }
            return b
          })
          return sourceSelection || item
        })
        src.forEach(item => {
          if (popularParlaysIDFWMarketGroup && item.selections && item.selections[0]) {
            item.selections[0].popularParlay = {iDFWMarketGroup: popularParlaysIDFWMarketGroup}
          }
          // let selectionOrigin = item.selections[0].origin || origin
          let selectionForInsert = {'selection': item.selections[0], 'market': item.market || item, 'origin': origin}
          context.dispatch('toggleBetslipSelection', selectionForInsert)
            // .then((r) => { console.log('Completed toggleBetslipSelection:', r) })
            .finally(async () => {
              n++
              // console.log('Selection added:', n)
              if (n === src.length) {
                // console.log('Last selection added')
                let now = new Date().getTime()
                let dt = Math.max(0, (1000 - (now - ts)))
                // console.log('sleep for:', dt)
                await sleep(dt)
                setTimeout(() => { context.commit('setAddingMiltipleSelections', false) }, 0)
                resolve(n)
              }
            })
        })
      })
    })
  }
}
export default actions



// WEBPACK FOOTER //
// ./src/store/modules/sports/betslipV2/actions/toggleSelection.js